import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialStoreOrdersBiFilterData,
  InitialStoreOrdersBiFilterDataVariables
} from "./types/InitialStoreOrdersBiFilterData";
import { StoreOrdersBi, StoreOrdersBiVariables } from "./types/StoreOrdersBi";
import {
  StoreOrdersBiDownload,
  StoreOrdersBiDownloadVariables
} from "./types/StoreOrdersBiDownload";

export const storeOrdersBiListQuery = gql`
  ${pageInfoFragment}
  query StoreOrdersBi(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreOrdersBiFilterInput!
  ) {
    storeOrdersBi(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          order_status
          order_date
          order_code
          store_order_code
        }
      }
    }
  }
`;

export const useStoreOrdersOmiQuery = makeBossQuery<
  StoreOrdersBi,
  StoreOrdersBiVariables
>(storeOrdersBiListQuery);

export const storeOrdersBiDownloadQuery = gql`
  ${pageInfoFragment}
  query StoreOrdersBiDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreOrdersBiFilterInput!
  ) {
    storeOrdersBi(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          vertical
          order_status
          store_order_status
          order_date
          shipping_schedule
          completed_at
          store_completed_at
          order_code
          store_order_code
          delivery_fee
          shipping_method_name
          payment_method_type
          voucher_code
          retail_price
          sales_discount_total
          selling_price
          voucher_discount_total
          price_paid
          user_id
          first_name
          last_name
          contact_no
          email
          street_address_1
          order_cancel_reason
          store_order_cancel_reason
          latitude
          longitude
          delivery_distance_in_km
          sales_discount_sm
          sales_discount_tenant
        }
      }
    }
  }
`;

export const useStoreOrdersOmiDownloadQuery = makeBossQuery<
  StoreOrdersBiDownload,
  StoreOrdersBiDownloadVariables
>(storeOrdersBiDownloadQuery);

export const initialStoreOrdersBiFilterDataQuery = gql`
  query InitialStoreOrdersBiFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialStoreOrdersBiFilterDataQuery = makeQuery<
  InitialStoreOrdersBiFilterData,
  InitialStoreOrdersBiFilterDataVariables
>(initialStoreOrdersBiFilterDataQuery);
